import api from "./base_url";

/**
 * Apply and validate a promo code against cart items
 * @param {string} code - Promo code
 * @param {Array} items - Cart items in [{ product: id, quantity: qty }] format
 * @returns {Promise<object>} - Backend response with discount details
 */
export const applyCouponApi = async (code, items) => {
  const payload = {
    code: code.trim().toUpperCase(),
    coupon_code: code.trim().toUpperCase(),
    items: items.map((i) => ({
      product: i.product || i.id,
      quantity: i.quantity || i.qty,
    })),
  };

  try {
    const res = await api.post("coupons/apply/", payload);
    return res.data;
  } catch (err) {
    if (err.response?.status === 404) {
      const res = await api.post("coupons/apply/", payload);
      return res.data;
    }
    throw err;
  }
};

/**
 * Fetch list of active promo codes with customer eligibility status
 * @returns {Promise<Array>} - List of coupons
 */
export const getAvailableCouponsApi = async () => {
  try {
    const res = await api.get("payment/coupons/available/");
    const data = res.data;
    if (Array.isArray(data)) return data;
    return data.coupons || data.results || data.data || [];
  } catch (err) {
    if (err.response?.status === 404) {
      const res = await api.get("coupons/available/");
      const data = res.data;
      if (Array.isArray(data)) return data;
      return data.coupons || data.results || data.data || [];
    }
    throw err;
  }
};

/**
 * Fetch full cart price summary with optional shipping state and coupon code
 * @param {Array} items - Cart items
 * @param {string} state - Shipping state name
 * @param {string} couponCode - Applied coupon code
 * @returns {Promise<object>} - Price summary including discount breakdown
 */
export const getCartPriceSummaryApi = async (items, state = "", couponCode = "") => {
  const payload = {
    items: items.map((i) => ({
      product: i.product || i.id,
      quantity: i.quantity || i.qty,
    })),
    state: state || "",
  };
  if (couponCode && couponCode.trim()) {
    payload.coupon_code = couponCode.trim().toUpperCase();
  }

  try {
    const res = await api.post("cart/price-summary/", payload);
    return res.data;
  } catch (err) {
    if (err.response?.status === 404) {
      const res = await api.post("payment/cart/price-summary/", payload);
      return res.data;
    }
    throw err;
  }
};
